module.exports = __webpack_public_path__ + "media/assets/icons/hfund-03e7b3c9d63f513a8d2b55540a9e71bb.svg";